import { uID } from "@green24/npm-javascript-utils";
import { APP_CONSTANTS } from "../models/constants/AppConstants";
import { AppUtils as GenericAppUtils } from "@green24/npm-preact-utils/src/class/AppUtils";

export class AppUtils extends GenericAppUtils {
	static get hasWindow() {
		return typeof window !== "undefined";
	}

	static withID(target, IDDescription) {
		Object.defineProperty(target, "id", {value: uID(IDDescription)});
		return target;
	}

	static get simulateBoxOpening() {
		if(this.isDev) {
			return localStorage.getItem(APP_CONSTANTS.LOCAL_STORAGE_SIMULATE_BOX_OPENING);
		}
		return false;
	}

	static get simulatePaymentProcess() {
		if(this.isDev) {
			return localStorage.getItem(APP_CONSTANTS.LOCAL_STORAGE_SIMULATE_PAYMENT_PROCESS);
		}
		return false
	}

	static get simulateWizardSessionCreation() {
		if(this.isDev) {
			return localStorage.getItem(APP_CONSTANTS.LOCAL_STORAGE_SIMULATE_WIZARD_SESSION_CREATION);
		}
		return false;
	}
}
